import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ORG_IMAGE, COMMUNITY_IMAGE } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";
import { Building2, Shield, HeartHandshake } from "lucide-react";

// Closing landing sections extracted from pages/Landing.jsx (Phase 15
// component split); behaviour unchanged.

export function ForOrgsSection() {
  return (
      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
          <Reveal className="lg:col-span-6">
            <img src={ORG_IMAGE} alt="Team collaborating" className="w-full h-[440px] object-cover rounded-3xl border border-forest/10" />
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.2em] text-terracotta/80 font-bold inline-flex items-center gap-2">
              <Building2 className="w-3.5 h-3.5" /> For organisations
            </div>
            <h2 className="font-display text-4xl sm:text-5xl text-forest mt-4 leading-tight tracking-tight">Post a role. Approve hours. Build belonging.</h2>
            <ul className="mt-8 space-y-4 text-forest/80 text-lg">
              {["Get independently verified — the badge volunteers look for before they apply.",
                "Publish opportunities with location, skills and time required.",
                "Approve volunteer hours and message participants in-platform.",
                "Show your impact publicly — a live page of hours mobilised, volunteers and stories."].map((t, i) => (
                <li key={t} className="flex items-start gap-3"><Shield className="w-5 h-5 text-forest mt-1 shrink-0" />{t}</li>
              ))}
            </ul>
            <Link to="/partners"><Button className="rounded-full bg-forest hover:bg-forest-hover mt-9 px-7 h-12 transition-transform hover:-translate-y-0.5">Partner with CivicHearth</Button></Link>
          </Reveal>
        </div>
      </section>
  );
}

export function FinalCtaSection() {
  return (
      <section className="bg-forest text-white py-24 mt-10 relative overflow-hidden">
        <div className="pointer-events-none absolute -top-32 right-0 w-[400px] h-[400px] rounded-full bg-terracotta/15 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl leading-tight tracking-tight">Mutual benefit. Measurable change.</h2>
            <p className="text-white/80 mt-5 max-w-lg text-lg leading-relaxed">A platform built on reciprocity — volunteers earn recognition and skills, organisations get the help they actually need, neighbours get a hand when it matters, and communities thrive.</p>
            <div className="flex flex-wrap gap-3 mt-9">
              <Link to="/login"><Button data-testid="final-cta-volunteer" className="rounded-full bg-terracotta hover:bg-terracotta-hover px-8 h-[52px] text-base shadow-lg shadow-black/20 transition-transform hover:-translate-y-0.5">Join the loop</Button></Link>
              <Link to="/partners"><Button data-testid="final-cta-org" variant="outline" className="rounded-full border-white/30 bg-transparent text-white hover:bg-white/10 hover:text-white px-7 h-[52px] text-base">For organisations</Button></Link>
            </div>
            <Link to="/help-request/new" data-testid="final-cta-help" className="mt-5 inline-flex items-center gap-1.5 text-sm text-white/80 hover:text-white underline decoration-white/30 underline-offset-4 transition-colors">
              <HeartHandshake className="w-4 h-4" /> Or just ask a neighbour for a hand
            </Link>
          </Reveal>
          <Reveal delay={0.15}>
            <img src={COMMUNITY_IMAGE} alt="Diverse community" className="w-full h-[380px] object-cover rounded-3xl" />
          </Reveal>
        </div>
      </section>
  );
}
